var map = {
	"./IMG-20250331-WA0013.jpg": 3582,
	"./IMG-20250402-WA0015.jpg": 1455,
	"./IMG-20250403-WA0002.jpg": 6060,
	"./IMG-20250410-WA0002.jpg": 2156,
	"./IMG-20250410-WA0006.jpg": 1192,
	"./IMG-20250410-WA0010.jpg": 5461,
	"./IMG-20250410-WA0014.jpg": 105,
	"./IMG-20250410-WA0016.jpg": 7387,
	"./IMG-20250410-WA0017.jpg": 2990,
	"./IMG-20250410-WA0018.jpg": 7997,
	"./IMG-20250410-WA0021.jpg": 9985,
	"./IMG-20250410-WA0022.jpg": 406,
	"./IMG-20250410-WA0023.jpg": 3571,
	"./IMG-20250410-WA0024.jpg": 6288,
	"./IMG-20250410-WA0025.jpg": 1869,
	"./IMG-20250410-WA0034.jpg": 2815,
	"./IMG-20250410-WA0036.jpg": 9405,
	"./IMG-20250410-WA0037.jpg": 8480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2796;